module.exports = __webpack_public_path__ + "static/media/importSeaEn.8c096f2a.png";